import BookmarkOutlinedIcon from '@mui/icons-material/BookmarkOutlined';
import { Box, IconButton, useTheme } from '@mui/material';
import { FunctionComponent } from 'react';
import { L3ServiceViewModel, Preference } from '../../model';

interface L3ServicePreferenceProps {
  l3Service: L3ServiceViewModel;
}

export const L3ServicePreference: FunctionComponent<L3ServicePreferenceProps> = ({ l3Service }) => {
  const theme = useTheme();
  const backgroundColor = l3Service.preference === Preference.Favourite ? theme.palette.primary.main : 'gray';

  return <Box sx={{ backgroundColor, borderRadius: 1, height: 'min-content', p: '1px', width: 'min-content' }}>
    <IconButton sx={{ p: 0 }}><BookmarkOutlinedIcon htmlColor="#fff" /></IconButton>
  </Box>;
};
